import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

import { LowerCasePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

/** Ligne de climat du calendrier : climat exploré, sinon le sien et sa commune, sinon un libellé générique. */
@Component({
  selector: 'vw-climate-banner',
  standalone: true,
  imports: [TranslatePipe, LowerCasePipe],
  templateUrl: './climate-banner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './climate-banner.component.scss'
})
export class ClimateBannerComponent {
  @Input() selectedClimateType: string | null = null;
  @Input() myClimateType: string | null = null;
  /** Commune de l'adresse, entre parenthèses après son climat. */
  @Input() city: string | null = null;
  @Output() pickerClick = new EventEmitter<void>();
}
